// extracted by mini-css-extract-plugin
export var divider = "_wn-0";